import { render } from "./CollectionCards.vue?vue&type=template&id=9d426200&scoped=true"
import script from "./CollectionCards.vue?vue&type=script&lang=js"
export * from "./CollectionCards.vue?vue&type=script&lang=js"

import "./CollectionCards.vue?vue&type=style&index=0&id=9d426200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d426200"]])

export default __exports__